import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AppBarPortal from '../components/AppBarPortal';
import AppLeftPortal from '../components/AppLeftPortal';
import AppFooterPortal from '../components/AppFooterPortal';

const styles = {
  pl: {
    paddingLeft: 25
  }
}

class ConsumerConsent extends React.PureComponent {

  state = {
    title: 'CONSENTIMIENTO DE PARTICIPACIÓN DE CONSUMIDORES'
  }

  componentDidMount() {
    document.body.classList.add("login");
    document.title = this.state.title + ' - CosmoCare';
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    return (
      <main style={{ display: 'block', padding: 25 }}>
        {!isMobile && <AppBarPortal />}
        {!isMobile && <AppLeftPortal />}
        {!isMobile && <AppFooterPortal />}
        
        <Grid container>
          <Grid item>
            <Typography variant='headline' align='center' paragraph>
              CONSENTIMIENTO DE PARTICIPACIÓN DE CONSUMIDORES
            </Typography>
            <Typography paragraph>
              CosmoCare me ha propuesto formar parte de su base de datos de consumidores y participar en sus 
              pruebas de evaluación de la aceptabilidad de productos cosméticos.
            </Typography>
            <Typography paragraph>
              Me comprometo a no participar al mismo tiempo en otros estudios con productos cosméticos, ya sea 
              con CosmoCare o con otro centro de estudios de actividad similar.
            </Typography>
            <Typography paragraph>
              He sido informado y soy consciente de los posibles riesgos (enrojecimiento, irritación, picor, 
              sequedad, malestar, granos, descamación, etc.), así como de que soy completamente libre de aceptar 
              la propuesta o rechazarla. En caso de que el producto probado provoque una reacción o una intolerancia, 
              lo notificaré inmediatamente a CosmoCare. Asimismo, me comprometo a comunicar en todo momento cualquier 
              tipo de enfermedad, alergia, o cualquier otra intolerancia cutánea o toma de medicamentos que pueda 
              afectar a la valoración organoléptica del producto.
            </Typography>
            <Typography paragraph>
              He leído y comprendido este escrito. Estoy satisfecho con la información recibida, he formulado todas las 
              preguntas que he creído conveniente y me han aclarado todas las dudas planteadas, y comprendo el alcance 
              y los riesgos del tratamiento. No obstante, puedo solicitar, en todo momento, información complementaria 
              a CosmoCare en el +34 690 012 345 durante los horarios de apertura o por correo electrónico en la 
              dirección help@cosmocare.eu
            </Typography>
            <Typography paragraph variant="subheading">
              CONFIDENCIALIDAD
            </Typography>
            <Typography paragraph>
              En calidad de miembro del panel de consumidores CosmoCare, soy consciente de que recibiré productos e 
              información sobre los estudios y que dicha información es estrictamente confidencial. Me comprometo, 
              en consecuencia, a mantener bajo estricta confidencialidad dichos productos e información. Se me enviará 
              la información específica para cada prueba junto al cuestionario de evaluación y será necesario tener 
              las modalidades de uso del producto (condiciones de uso, precauciones de uso en caso de ser pertinentes, etc.).
            </Typography>
            <Typography paragraph variant="subheading">
              PROTECCIÓN DE DATOS DE CARÁCTER PERSONAL
            </Typography>
            <Typography paragraph>
              De conformidad con la normativa vigente en materia de protección de datos, le informamos que sus datos serán 
              tratados por COSMOCARE EXPERT, SOCIEDAD LIMITADA, con NIF B67255455 y domicilio social en Calle Diputación, 
              núm. 180, 6ª planta Oficinas B-C, 08011 Barcelona (en adelante, “CosmoCare”), con las finalidades de: a) 
              realizar pruebas de evaluación de la aceptabilidad de productos cosméticos; b) llevar a cabo las gestiones 
              y trámites derivadas de las mismas. Asimismo, trataremos sus datos de salud, tales como los relativos a 
              alergias, enfermedades graves que padezca o medicación con la única finalidad de reafirmar que las pruebas 
              de evaluación de la aceptabilidad de productos cosméticos no supongan un menoscabo o riesgo para su salud. 
              La recogida y tratamiento de sus datos personales son necesarios para prestar el servicio descrito, de tal 
              forma que la negativa a suministrarlos supondrá la imposibilidad de prestar dicho servicio. La legitimación 
              del tratamiento de los datos obtenidos es su consentimiento. Sus datos podrán ser comunicados a la Agencia 
              Española de Medicamentos y Productos Sanitarios para las finalidades de notificación de efectos no deseados 
              de productos cosméticos. Los datos obtenidos con motivo del estudio descrito serán conservados durante el 
              tiempo necesario para la realización de las finalidades para las que fueron recogidos y atención a las 
              posibles responsabilidades derivadas de las mismas, salvo que el usuario solicite su baja a CosmoCare, 
              se oponga o revoque su consentimiento. Asimismo, en el supuesto de facilitar datos de terceros, 
              manifiesta contar con el consentimiento de los mismos y se compromete a trasladarle la información 
              contenida en esta cláusula. Usted podrá ejercitar sus derechos de acceso, rectificación, 
              supresión, oposición, limitación y portabilidad, así como de retirar su consentimiento, mediante 
              el email contact@cosmocare.eu o correo postal, en la dirección Calle Diputación, núm. 180, 6ª 
              planta Oficinas B-C, 08011 Barcelona. Del mismo modo, cuando el interesado considere que CosmoCare 
              ha vulnerado los derechos que le son reconocidos por la normativa aplicable en protección de datos 
              podrá reclamar ante la Agencia Española de Protección de Datos.
            </Typography>
            <Typography paragraph>
              En el caso de incumplimiento de estas condiciones por parte del consumidor, CosmoCare podrá 
              decidir sobre la continuidad del consumidor en la participación de los test.
            </Typography>
            <Typography paragraph>
              <strong>
                MEDIANTE LA MARCACIÓN DE LA CASILLA CORRESPODIENTE EN EL FORMULARIO DE RECOGIDA DE DATOS, USTED 
                ACEPTA PARTICIPAR EN LOS TESTS DE CONSUMIDORES RESPETANDO LAS CONDICIONES DE USO FACILITADAS POR 
                COSMOCARE PARA CADA PRODUCTO Y EN TÉRMINOS ESTABLECIDOS EN LA PRESENTE CLÁUSULA INFORMATIVA.
              </strong>
            </Typography>
          </Grid>
        </Grid>
      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles)(ConsumerConsent)
  )
);


// WEBPACK FOOTER //
// ./src/modules/shared/pages/ConsumerConsent.js